import { CONSTANTS } from '../_data/lookups.js';
import { extractToolStepsFromStep } from './stepExpansion.js';
export function getInputRoleSpecEntriesFromTool(tool) {
    return Object.entries(tool.roleSpec.inputRoleByName);
}
export function getOutputRoleSpecEntriesFromTool(tool) {
    return Object.entries(tool.roleSpec.outputRoleByName);
}
export function getInputRoleNamesFromTool(tool) {
    return getInputRoleSpecEntriesFromTool(tool).map(([roleName]) => roleName);
}
export function getIntrinsicInputByRoleName(tool) {
    return (tool.intrinsicInputByRoleName ?? {});
}
export function getIntrinsicInputRoleNames(tool) {
    const inputRoleNameSet = new Set(getInputRoleNamesFromTool(tool));
    const intrinsicRoleNames = Object.keys(getIntrinsicInputByRoleName(tool));
    for (const roleName of intrinsicRoleNames) {
        if (!inputRoleNameSet.has(roleName)) {
            throw new Error(`Intrinsic input role '${roleName}' is not declared by Tool '${tool.handle}'.`);
        }
    }
    return getInputRoleNamesFromTool(tool).filter((roleName) => intrinsicRoleNames.includes(roleName));
}
export function getBindableInputRoleNames(tool) {
    const intrinsicRoleNameSet = new Set(getIntrinsicInputRoleNames(tool));
    return getInputRoleNamesFromTool(tool).filter((roleName) => !intrinsicRoleNameSet.has(roleName));
}
export function getOutputRoleNamesFromTool(tool) {
    return getOutputRoleSpecEntriesFromTool(tool).map(([roleName]) => roleName);
}
export function getSingleInputRoleNameFromToolStep(toolStep) {
    const inputRoleNames = toolStep.roleBindingSpec.inputBindings;
    if (inputRoleNames.length !== 1) {
        throw new Error(`Expected exactly one input role for toolStep ${toolStep.stepKey}; got ${inputRoleNames.length}` // ATTENTION: impure
        );
    }
    return inputRoleNames[0]; // ATTENTION
}
export function getSingleInputRoleNameFromTool(tool) {
    const inputRoleNames = Object.keys(tool.roleSpec.inputRoleByName);
    if (inputRoleNames.length !== 1) {
        return null; // ATTENTION: should we throw instead?
    }
    return String(inputRoleNames[0]);
}
;
export function extractResourceTypeHandleFromRole(role) {
    return role.resourceTypeHandle ?? null;
}
export function extractToolStepsFromWorkflow(workflow, order = { loopCaseOrder: 'when-what' }) {
    const toolSteps = [];
    for (const threadSteps of workflow.stepsByThreadIndex) {
        for (const step of threadSteps) {
            toolSteps.push(...extractToolStepsFromStep(step, order));
        }
    }
    return toolSteps;
}
export function extractToolsFromWorkflow(workflow, toolMap) {
    const toolSteps = extractToolStepsFromWorkflow(workflow);
    const toolHandles = new Set();
    const tools = [];
    for (const toolStep of toolSteps) {
        toolHandles.add(toolStep.toolHandle);
    }
    for (const toolHandle of toolHandles) {
        const tool = toolMap.get(toolHandle);
        if (!tool) {
            throw new Error(`Tool with handle '${toolHandle}' not found in toolMap.`); // ATTENTION
        }
        tools.push(tool);
    }
    return tools;
}
export function extractRoleSpecByDirectionFromTool(tool) {
    return {
        inputRoleByName: new Map(getInputRoleSpecEntriesFromTool(tool)),
        outputRoleByName: new Map(getOutputRoleSpecEntriesFromTool(tool)),
    };
}
export function extractRoleSpecByDirectionByToolHandleFromWorkflow(workflow, toolMap) {
    const roleSpecByDirectionByToolHandle = new Map();
    for (const tool of extractToolsFromWorkflow(workflow, toolMap)) {
        roleSpecByDirectionByToolHandle.set(tool.handle, extractRoleSpecByDirectionFromTool(tool));
    }
    return roleSpecByDirectionByToolHandle;
}
export function extractSingleBranchableOutputResourceTypeHandle(tool) {
    const outputRoleSpecEntries = getOutputRoleSpecEntriesFromTool(tool).filter(([roleName]) => roleName !== CONSTANTS.Cosmos.RoleNames.ErrorOutput);
    if (!outputRoleSpecEntries[0] || outputRoleSpecEntries.length !== 1) {
        throw new Error(`Tool ${tool.handle} must have exactly one branchable output resource type to be branchable/loopable`);
    }
    return extractResourceTypeHandleFromRole(outputRoleSpecEntries[0][1]);
}
